import { useAttachmentSignedUrl } from '@/hooks/useAttachmentSignedUrl';
import { ImageIcon, Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface AttachmentImageProps {
  filePath: string;
  alt?: string;
  className?: string;
  containerClassName?: string;
  onClick?: () => void;
  asLink?: boolean;
}

export const AttachmentImage = ({ 
  filePath, 
  alt = 'Anexo', 
  className,
  containerClassName,
  onClick,
  asLink = false
}: AttachmentImageProps) => {
  const { signedUrl, isLoading, error } = useAttachmentSignedUrl(filePath);

  const containerStyles = cn(
    "flex items-center justify-center",
    containerClassName
  );

  if (isLoading) {
    return (
      <div className={containerStyles}>
        <Loader2 className="w-6 h-6 animate-spin text-white/40" />
      </div>
    );
  }

  if (error || !signedUrl) {
    return (
      <div className={containerStyles}>
        <ImageIcon className="w-6 h-6 text-white/40" />
      </div>
    );
  }

  const image = (
    <img 
      src={signedUrl}
      alt={alt}
      className={className}
      onClick={!asLink ? onClick : undefined}
    />
  );

  if (asLink) {
    return (
      <a 
        href={signedUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="block w-full h-full"
      >
        {image}
      </a>
    );
  }

  return image;
};
